interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export function Modal({ isOpen, onClose, children }: ModalProps): JSX.Element {
  if (!isOpen) {
    return <></>;
  }

  return (
    <div className="fixed inset-0 z-2000 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center"
        onClick={onClose}
        aria-hidden="true"
      />

      <div className="flex justify-center items-center z-50 w-[640px] rounded-lg">{children}</div>
    </div>
  );
}
